import { JournalEntryLine } from '../types';

// Validate email
export const validateEmail = (email: string): string | null => {
  if (!email) {
    return 'Email is required';
  }
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!re.test(email)) {
    return 'Invalid email format';
  }
  return null;
};

// Validate password
export const validatePassword = (password: string): string | null => {
  if (!password) {
    return 'Password is required';
  }
  if (password.length < 8) {
    return 'Password must be at least 8 characters';
  }
  return null;
};

// Validate required field
export const validateRequired = (value: any, fieldName: string = 'Field'): string | null => {
  if (!value || (typeof value === 'string' && !value.trim())) {
    return `${fieldName} is required`;
  }
  return null;
};

// Validate number
export const validateNumber = (value: any, fieldName: string = 'Field'): string | null => {
  if (value === null || value === undefined || value === '') {
    return `${fieldName} is required`;
  }
  if (isNaN(value)) {
    return `${fieldName} must be a number`;
  }
  return null;
};

// Validate positive number
export const validatePositiveNumber = (value: any, fieldName: string = 'Field'): string | null => {
  const numberError = validateNumber(value, fieldName);
  if (numberError) return numberError;
  
  if (parseFloat(value) < 0) {
    return `${fieldName} must be positive`;
  }
  return null;
};

// Validate date
export const validateDate = (date: string, fieldName: string = 'Date'): string | null => {
  if (!date) {
    return `${fieldName} is required`;
  }
  const d = new Date(date);
  if (isNaN(d.getTime())) {
    return `${fieldName} is invalid`;
  }
  return null;
};

// Validate account code format
export const validateAccountCode = (code: string): string | null => {
  if (!code) {
    return 'Account code is required';
  }
  if (!/^\d{4,}$/.test(code)) {
    return 'Account code must be at least 4 digits';
  }
  return null;
};

// Validate journal entry balance
export const validateJournalBalance = (lines: JournalEntryLine[]): string | null => {
  if (!lines || lines.length === 0) {
    return 'At least one journal line is required';
  }

  let totalDebit = 0;
  let totalCredit = 0;

  for (const line of lines) {
    totalDebit += parseFloat(String(line.debit_amount || 0));
    totalCredit += parseFloat(String(line.credit_amount || 0));
  }

  const difference = Math.abs(totalDebit - totalCredit);
  
  if (difference > 0.01) {
    return 'Journal entry is not balanced. Debits must equal credits.';
  }

  return null;
};
